
<div class="page-wrapper">
  <div class="page-container">
    <div class="header-title">
      <button class="btn-text-primary"
        [class.active]="router.url === '/healthcheck/member/myprofile'"
        routerLink="/healthcheck/member/myprofile">
        <img width="18" height="18" src="assets/img/Arrow_left.png">
        <app-text size="editProfile" weight="m" color="gray-700">返回健康檔案</app-text>
      </button>
    </div>

    @if(isLoading){
    <app-text size="l" weight="m" color="gray-900">
      資料載入中......
    </app-text>
    }@else{
    <div class="card-content register-card-content">

      <div class="confirm-body">
        <div class="confirm-body-item">
          <div class="confirm-body-item-btn">
            <app-text size="editName" weight="m" color="gray-900">
            {{ 'modify-info.name' | translate }}
            </app-text>
            <button
              mat-button
              (click)="openModifyNameDialog()"
            >
              <img width="18" height="18" src="assets/img/Edit_deep.png">
            </button>
          </div>

            <app-text size="editFile" weight="s" color="gray-900" style="margin-top: 16px;">
              {{ name }}
            </app-text>
        </div>
      </div>

      <div class="confirm-body">
        <div class="confirm-body-item">
          <app-text size="editName" weight="m" color="gray-900" style="margin-bottom: 18px; margin-top: 8px;">
            {{ 'modify-info.id-number' | translate }}
          </app-text>
          <div class="confirm-body-item-btn">
            <app-text size="editFile" weight="s" color="gray-900" style="margin-bottom: 8px;">
              {{ idNumber }}
            </app-text>
          </div>
        </div>
      </div>

      <div class="confirm-body">
        <div class="confirm-body-item">
          <div class="confirm-body-item-btn">
          <app-text size="editName" weight="m" color="gray-900">
            {{ 'modify-info.phone' | translate }}
          </app-text>
          @if (phone) {
            <button
              mat-button
              (click)="openSavePhoneDialog()"
            >
              <img width="18" height="18" src="assets/img/Edit_deep.png">
            </button>
          } @else {
            <button
              mat-button
              (click)="openSavePhoneDialog()"
              class="btn-outline-primary btn-size-s"
            > {{ 'modify-info.add-phone' | translate }}
            </button>
          }
          </div>
            @if (phone) {
              <div class="confirm-body-item-verify">
                <app-text size="editFile" weight="s" color="gray-900">
                  {{ phone }}
                </app-text>
                <span
                  >{{ 'modify-info.verified' | translate}}
                  <img
                    width="20"
                    height="20"
                    ngSrc="assets/img/i-success-fill-green.svg"
                    alt=""
                  />
                </span>
              </div>
            } @else {
              <p>{{ 'modify-info.bind-phone-hint' | translate }}</p>
            }
            &nbsp;
        </div>
      </div>

      <div class="confirm-body">
        <div class="confirm-body-item">
          <div class="confirm-body-item-btn">
            <app-text size="editName" weight="m" color="gray-900">
              {{ 'modify-info.email' | translate }}
            </app-text>
            @if (email) {
              <button
              mat-button
              (click)="openModifyEmailDialog()"
            >
              <img width="18" height="18" src="assets/img/Edit_deep.png">
            </button>
            } @else {
              <button
              mat-button
              (click)="openModifyEmailDialog()"
              class="btn-outline-primary btn-size-s"
            >
              {{ 'modify-info.add-email' | translate }}
            </button>
            }
          </div>
          @if (email) {
            <div class="confirm-body-item-verify">
              <app-text size="editFile" weight="s" color="gray-900">
                {{ email }}
              </app-text>
              <span
                >{{ 'modify-info.verified' | translate
                }}<img
                  width="20"
                  height="20"
                  ngSrc="assets/img/i-success-fill-green.svg"
                  alt=""
              /></span>
            </div>
          } @else {
            <p>{{ 'modify-info.bind-email-hint' | translate }}</p>
          }
        </div>
      </div>


      <!-- 新版 -->
      <div class="confirm-body">
        <div class="confirm-body-item-last">
          <div class="confirm-body-item-btn">
            <app-text size="editName" weight="m" color="gray-900">
              {{ 'modify-info.modify-password' | translate }}
            </app-text>
              <button
              mat-button
              (click)="modifyPassword()"
            >
              <img width="18" height="18" src="assets/img/Edit_deep.png">
            </button>
          </div>
          <app-text size="editFile" weight="s" color="gray-400" style="margin-top: 16px;">密碼每日只能變更一次</app-text>
        </div>
      </div>


      <!-- 舊版 -->
      <!-- <div class="input-block">
        <label class="input-title">{{
          'modify-info.modify-password' | translate
        }}</label>
        <div class="input-password-block">
          <div class="input-group input-btn-right">
            <input
              matInput
              [type]="isPasswordVisible ? 'text' : 'password'"
              [formControl]="currentPasswordControl"
              [ngClass]="{
                'input-error': showPasswordError && currentPasswordControl.invalid,
              }"
              [placeholder]="'modify-info.origin-password-placeholder' | translate"
            />
            <button
              mat-icon-button
              type="button"
              (click)="togglePasswordVisibility()"
              class="input-password-btn"
            >
              <img
                [src]="
                  isPasswordVisible
                    ? 'assets/img/i-eye.svg'
                    : 'assets/img/i-eye-closed.svg'
                "
                alt="toggle visibility"
              />
            </button>
          </div>
          <button
            mat-button
            (click)="modifyPassword()"
            [disabled]="isPasswordChangeDisabled"
            [ngClass]="{ 'btn-disabled': isPasswordChangeDisabled }"
          ><img width="18" height="18" src="assets/img/Edit_deep.png">
          </button>
        </div>
        @if ((showPasswordError && passwordErrorMessage) || currentPasswordControl.invalid ) {
          <mat-error class="input-error-msg">{{ passwordErrorMessage }}</mat-error>
        }
        @if (isPasswordChangeDisabled) {
        <div class="password-change-hint">
          <img
                  width="16"
                  height="16"
                  ngSrc="assets/img/i-warn-outline.svg"
                  alt=""
          />
          <span>{{ 'modify-info.password-change-daily-limit' | translate }}</span>
        </div>
        }
      </div>
    </div> -->
  </div>

  @if (showPersonalConsentButton) {
    <div class="card-content register-card-content">
      <div class="confirm-body">
        <div class="confirm-body-item-concent">
          <div class="confirm-body-item-btn">
            <app-text size="editName" weight="m" color="gray-900">
              {{ 'modify-info.personal-concent' | translate }}
            </app-text>
            <button mat-button (click)="modifyPersonalConsent()">
              <img width="18" height="18" src="assets/img/Edit_deep.png">
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  }
    

</div>
